'use client';

import { useEffect } from 'react';

/**
 * Enables gentle scroll-snapping on the landing page only. `proximity` (not
 * `mandatory`) is deliberate: a small scroll settles back to the current
 * section, a larger scroll drifts on to the next — and because the feature
 * animations are scroll-position-driven (framer useScroll), the snap glides the
 * animation to its rest state instead of leaving it stuck half-played.
 *
 * Scoped by toggling a class on <html> so it never affects the dashboard/app.
 * Disabled when the user prefers reduced motion.
 */
export function LandingScrollSnap() {
  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    const el = document.documentElement;
    el.classList.add('landing-snap');
    return () => el.classList.remove('landing-snap');
  }, []);
  return null;
}
